module.exports = __webpack_public_path__ + "static/media/SPOTlight.222436b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layers/SPOTlight.png
// module id = 168
// module chunks = 0